import { render, staticRenderFns } from "./uploadImage.vue?vue&type=template&id=15c53b16&ref=uploadImage"
import script from "./uploadImage.vue?vue&type=script&lang=js"
export * from "./uploadImage.vue?vue&type=script&lang=js"
import style0 from "./uploadImage.vue?vue&type=style&index=0&id=15c53b16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports